import { Box, IconButton, Typography, useTheme } from "@mui/material";

import { ArrowBack } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { snakeToTitleCase } from "src/reusable/Functions";
import { useUIStore } from "../../stores/UIStore";
import { TArtifact } from "../../types";
import ArtifactProgressAlert from "./ArtifactProgressAlert";

type TArtifactsHeader = {
  currentArtifact: TArtifact | undefined;
};

const ArtifactsHeader = ({ currentArtifact }: TArtifactsHeader) => {
  const theme = useTheme();

  const { closeArtifact } = useUIStore();
  const closeArtifactItem = closeArtifact;

  const isLoading = currentArtifact ? currentArtifact.isLoading : false;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "auto",
        minHeight: "fit-content",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1.5,
          bgcolor: grey[100],
          borderBottom: `1px solid ${theme.palette.divider}`,
          py: 0.5,
        }}
      >
        <IconButton
          data-testid="aa-artifact-detail-back"
          aria-label="Back to artifacts"
          onClick={closeArtifactItem}
        >
          <ArrowBack />
        </IconButton>
        <Typography variant="body1">
          {currentArtifact?.type && snakeToTitleCase(currentArtifact?.type)}
        </Typography>
      </Box>
      <ArtifactProgressAlert
        isLoading={isLoading}
        currentArtifact={currentArtifact}
      />
    </Box>
  );
};

export default ArtifactsHeader;
